import React, { useEffect, useRef, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPrice, istl, toPrice } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Cookies from "js-cookie";
import ScrollWrap from "../ui/ScrollWrap";

export default function InventoryList(props) {

    const scrollRef = useRef();

    const {
        controller = "",
        signal = {},
        view = "",
        state = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        filters = { sort: "id", localSort: "id" },
        setFilters = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        seachResults = {},
        isTitleLink = false,
        filterLocal = () => { },
        infinite = true,
        header = "",
        search = false,
        skip = false,
        onSelectedRowClick = () => { },
        switchView = () => { }
    } = props;


    const [block, setBlock] = useState((search) ? true : false);

    const buffer = 80;

    //const min = (view === "inventory" || view === "orders") ? false : true;

    const min = (view === "history_full" || state.tabs === "orders" && state.history_checked) ? true : false;


    const toggleSort = (_key) => {
        if (filters.sort === _key) {
            setFilters({ ...filters, "sort": "id", "dynamic": true })
        } else {
            setFilters({ ...filters, "sort": _key, "dynamic": true })
        }
    }


    const toggleLocalSort = (_key) => {

        let _f = "stock_id";
        if (data.length > 0 && data[0].hasOwnProperty("init")) {
            _f = "init";
        }

        if (filters.localSort === _key) {
            setFilters({ ...filters, "localSort": [_f], "dynamic": false })
        } else {
            setFilters({ ...filters, "localSort": _key, "dynamic": false })
        }

    }


    const colSort = (_text, _key, _local_key) => {

        if (filters?.type === "keyword") {
            return (<>{_text}</>)
        }

        if (!filters.dynamic) {
            const match = (filters.localSort === _key);
            if (!match) {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            } else {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            }
        }
        const match = (filters.sort === _key);
        if (!match) {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }

    const columns = [
        {
            stock: true, title_link: true, min: true, key: "available_on_hand", title: <>aOH</>, width: 35, render: (e, f) => {
                if (istl(f)) { return <div style={{ "textAlign": "center" }}>-</div>; } return (e) ? e : "";
            }
        },
        {
            stock: true, title_link: true, min: true, key: "available_on_order", title: <>aOO</>, width: 35, render: (e, f) => {
                if (istl(f)) { return <div style={{ "textAlign": "center" }}>-</div>; } return (e) ? e : "";
            }
        },
        {
            stock: true, title_link: true, min: true, key: "price", title: <>Price</>, width: 60, render: (e, f) => {

                const _price = istl(f) ? f?.title_link?.price : e;

                if (f.sell_price > 0 && f.sell_price !== _price) {
                    return (<strong style={{ "color": "var(--text-red)" }}>{drawPrice(f.sell_price, true)}</strong>)
                }

                return drawPrice(_price, true);
            }
        },
        {
            stock: true, title_link: true, min: true, key: "binding", align: "left", title: <>Bd</>, width: 35, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.binding : e;
            }
        },
        {
            stock: true, title_link: true, min: true, key: "title", align: "left", title: colSort("Title", "title", "title"), grow: true, width: 217, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.title : e;
            }
        },
        {
            stock: true, title_link: true, min: false, key: "author", align: "left", title: colSort("Author", "author", "author"), width: 110, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.author : e;
            }
        },
        {
            stock: true, title_link: true, min: false, key: "publication_date", align: "left", title: colSort("PbDt ", "publication_date"), width: 65, render: (e, f) => {
                return bm_date(e, "MM/YY");
            }
        },


        {
            stock: false, title_link: true, min: false, key: "rank", align: "right", title: colSort("Rank", "rank"), width: 73, render: (e, f) => {
                return f?.title_link?.rank
            }
        },

        {
            stock: true, title_link: true, min: false, key: "primary_code", align: "left", title: colSort("ISBN", "isbn", "primary_code"), width: 150, render: (e, f) => {

                if (istl(f)) {
                    return f.title_link.primary_code;
                } else {
                    return (f.condition_code && f.condition_code !== " " && e) ? e.slice(0, -1) + f.condition_code : e
                }


            }
        },

        {
            stock: true, title_link: false, min: false, key: "class", align: "left", title: colSort("Class", "class", "category_1"), width: 80, render: (e, f) => {
                return (istl(f)) ? <span style={{ fontFamily: "monospace" }}>{f?.category_1}</span> : <span style={{ fontFamily: "monospace" }}>{f?.category_1}</span>;
            }
        },
        {
            stock: true, title_link: false, min: false, key: "subclass", align: "left", title: "Subclass", width: 80, render: (e, f) => {
                return (istl(f)) ? <span style={{ fontFamily: "monospace" }}>{f?.category_2}</span> : <span style={{ fontFamily: "monospace" }}>{f?.category_2}</span>;
            }
        },


        {
            stock: true, title_link: false, min: false, key: "supplier_1", align: "left", title: colSort("Supl", "supplier", "supplier_1"), width: 55, render: (e, f) => {
                return (istl(f)) ? "---" : e;
            }
        },

        {
            stock: true, title_link: true, min: false, key: "receive_date", align: "left", title: "1stRcvd", width: 80, render: (e) => bm_date(e)
        },



        {
            stock: true, title_link: true, min: false, key: "original_publisher", align: "left", title: "Publisher", width: 80
        },

        {
            stock: true, title_link: true, min: false, key: "section", align: "left", title: "Se", width: 60
        },




    ]


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }

        if (_rows > 1) {
            setAlign("start")
        } else {
            setAlign("auto");
        }

        const nextIndex = data.findIndex(item => item?.stock_id === selected?.stock_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.stock_id === selected?.stock_id) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {

        if (loading || !filters.dynamic) {
            if (filters?.type === "keyword") {
                setLoading(true);
                const event = new CustomEvent("callKeywordNext", { detail: data });
                window.dispatchEvent(event);
                setTimeout(() => {
                    setLoading(false)
                }, 100)
            }
            return;
        }
        setLoading(true);

        pubCall("stock.getNext", { ...filters, "limit": 20, "stock_id": data[data.length - 1]?.stock_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("stock.getPrevious", { ...filters, "limit": 20, "stock_id": data[0]?.stock_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }



    const fetch = (_start = false, _last = false) => {


        if (window.skip_inventory_fetch) {
            // don't like this option, (stops filter changes from re-firing getInit on searches) might be better to put getInit in controller and use a ref. 
            window.skip_inventory_fetch = false;
            return;
        }
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        let _filters = { ...filters };
        if (Cookies.get("inventory_stock_id")) {
            _filters.stock_id = Cookies.get("inventory_stock_id");
        } else {
            if (selected?.stock_id) {

                _filters.stock_id = selected?.stock_id;
            }
        }

        // Don't search empty titlelink stock_id (prefix with no-stock)
        if (_filters.stock_id && _filters.stock_id.includes("no-stock")) {
            delete _filters.stock_id;
        }

        if (_start || _last) {
            delete _filters.stock_id;
        }

        if (_last) {
            pubCall("stock.getLast", _filters, (_s, _r) => {
                if (_s) {
                    setData(_r);
                    setSelected((_r?.length > 0) ? _r[_r.length - 1] : {})
                }
                setLoading(false);
            })
            return;
        }

        pubCall("stock.getInitial", _filters, (_s, _r) => {


            if (block) {
                return;
                setBlock(false);
            }


            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }

                if (_start) {
                    setData(_r.rows_next);
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                    setLoading(false)
                    return;
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters, window.inventory_refresh]);




    const getColumns = () => {
        if (isTitleLink) {
            return (min) ? columns.filter(item => item.min && item.title_link) : columns.filter(item => item.title_link)
        } else {
            return (min) ? columns.filter(item => item.min && item.stock) : columns.filter(item => item.stock)
        }
    }



    // if(props?.hide){
    //     return <></>;
    // }

    const toggleExpanded = () => {
        (state.view === "inventory_full") ? switchView("inventory") : switchView("inventory_full")
    }

    return (
        <>
            <div style={{ display: (props?.hide) ? "none" : "block" }} className="ui-arrow-wrapper">
                <ScrollWrap allow_nudge={true} controller={controller} route={route} ref={scrollRef} reset={state?.view} width={1420}>
                    <VirtualTable
                        resetPos={props.resetPos}
                        getStart={() => {
                            fetch(true);
                        }}
                        getEnd={() => {
                            fetch(false, true)
                        }}
                        controller={controller}
                        columns_editable={false}
                        medium={true}
                        header={header}
                        className={(view === "inventory" || view === "inventory_full") ? "" : "dimmed"}
                        onRowClick={(item, event, index) => {
                            if (item?.stock_id === selected?.stock_id && (view == "inventory" || view === "inventory_full")) {
                                onSelectedRowClick();
                            } else {
                                if (view !== "inventory_full" && view !== "inventory") {
                                    props.switchView((view === "inventory_full") ? "inventory_full" : "inventory")
                                } else {
                                    props.switchView((view === "inventory_full") ? "inventory_full" : "inventory")
                                    setAlign("auto"); setSelected(item)
                                }



                            }
                        }}
                        next={next}
                        prev={prev}
                        scrollbar={true}
                        scrollindicator={true}
                        infinite={infinite}
                        align={align}
                        disable_scroll={!(view == "inventory" || view === "inventory_full")}
                        row_key={"stock_id"}
                        onLoadMore={(_start, _end, _prepend) => {
                            if (_prepend) {
                                if (data?.length > 0 && data[0]?.number !== 1) {
                                    fetchPrev()
                                }
                            } else {
                                if (data?.length > 0) {
                                    fetchNext();
                                }

                            }
                        }}
                        current={selected}
                        data={filterLocal(data)}
                        columns={getColumns()}
                        width={(min) ? 398 : ""}
                        fullWidth={(state?.view === "inventory_full") ? false : true}
                        loading={loading}
                        offset={449}
                        height={202}
                        route={route}
                    />
                </ScrollWrap>

                <div onClick={() => toggleExpanded()} className="ui-arrow">
                    <div style={{ "transform": (state?.view === "inventory_full") ? "rotate(90deg)" : "rotate(-90deg)", "marginRight": (state?.view === "inventory_full") ? "-5px" : "5px" }}>
                        <SortIcon />
                    </div>
                </div>
            </div>
        </>
    )
}